/**
 * Hook para obtener datos de inventario usando React Query
 * Hook to get inventory data using React Query
 */

import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { InventoryApiAdapter } from '../adapters';
import { InventoryApiResponse } from '../models/InventoryApiResponse';
import { InventoryFilters } from '../models/InventoryFilters';

interface UseInventoryDataProps {
  filters?: InventoryFilters;
}

export const useInventoryData = ({ filters }: UseInventoryDataProps = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const inventoryAdapter = new InventoryApiAdapter(httpClient);

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<InventoryApiResponse>({
    queryKey: ['inventoryReport', filters],
    queryFn: () => inventoryAdapter.getInventoryReport(filters),
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000, // 5 minutos
    // Mantener los datos anteriores mientras se cargan los nuevos filtros
    // Keep previous data while fetching new filters
    keepPreviousData: true,
  });

  return {
    data: response?.data,
    products: response?.data?.products || [],
    summary: response?.data?.summary,
    filters: response?.data?.filters,
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};
